import { Machine } from "xstate";

const requestResetPasswordMachine = Machine({
  id: "request-reset-password",
  initial: "idle",
  states: {
    idle: {
      on: {
        REQUEST: "loading",
      },
    },
    loading: {
      on: {
        RESOLVE: "success",
        REJECT: "failure",
      },
    },
    success: {
      type: "final",
    },
    failure: {
      on: {
        LOGIN: "loading",
      },
    },
  },
});

export default requestResetPasswordMachine;
